module.exports = __webpack_public_path__ + "static/img/wen.3e622a74.png";